import { createAsyncThunk } from '@reduxjs/toolkit';
import NewsService from '../../../epics/common/news';

export const getLatestNews = createAsyncThunk(
    'news/getLatest',
    async ({ lang, limit = 3 }, { rejectWithValue }) => {
        try {
            const response = await NewsService.getLatestNews(lang, limit);
            return response?.data ?? response;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.error || 'Error fetching latest news',
            );
        }
    },
);

export const getNewsList = createAsyncThunk(
    'news/getList',
    async (params, { rejectWithValue }) => {
        try {
            const response = await NewsService.getNewsList(params);
            return response;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.error || 'Error fetching news list',
            );
        }
    },
);

export const getNewsBySlug = createAsyncThunk(
    'news/getBySlug',
    async ({ slug, lang }, { rejectWithValue }) => {
        try {
            const response = await NewsService.getNewsBySlug(slug, lang);
            return response?.data ?? response;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.error || 'Error fetching news article',
            );
        }
    },
);
